import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useEffect } from "react";

export default function Modal({ open, onOpenChange, title, subtitle, children, testId }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => (document.body.style.overflow = "");
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onOpenChange(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onOpenChange]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid={testId}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            onClick={() => onOpenChange(false)}
          />
          <motion.div
            className="relative z-10 w-full max-w-lg rounded-3xl bg-[#171B22] border border-[#C9A44C]/25 p-7 md:p-9 shadow-[0_30px_80px_rgba(0,0,0,0.6)] max-h-[90vh] overflow-y-auto"
            initial={{ opacity: 0, y: 30, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.97 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          >
            <button
              data-testid="modal-close"
              onClick={() => onOpenChange(false)}
              className="focus-gold absolute top-5 right-5 text-[#9AA3AF] hover:text-white transition-colors"
              aria-label="Close"
            >
              <X size={22} />
            </button>
            <div className="flex items-center gap-3 mb-1">
              <img src="/markonlyvector.png" alt="" className="h-7 w-auto opacity-90" />
              <h3 className="text-2xl text-[#C9A44C]">{title}</h3>
            </div>
            {subtitle && <p className="text-[#9AA3AF] mb-6 mt-1">{subtitle}</p>}
            <div className="mt-5">{children}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
